import { AlqBase } from '@/models/query/AlqBase'

export class AlqIdentityToken extends AlqBase {    

    public login:string
    public pass:string

    constructor({login = "",pass=""} = {}) {        
        super(...arguments)
        this.login = login
        this.pass = pass
    }
}